import Accordion from '@/common/components/Accordion';
import { formatCurrency, formatPercentage } from '@/common/utils/formatters';
import { CompanyData } from '@/features/companies/types/companies.type';
import { UpdateFinancialModal } from '@/features/privateCompanies/pages/Update/components/UpdateFinancialModal';
import { CircleChevronDownIcon, DollarSignIcon } from 'lucide-react';
import { billIntegrationProcess } from '../constants/billIntegrationProcess.constant';

const FinancialSection = ({ company }: { company?: CompanyData }) => {
  return (
    <Accordion
      defaultOpen
      head={(
        <div className="flex items-center gap-x-3">
          <div onClick={(e) => e.stopPropagation()}>
            <UpdateFinancialModal company={company} />
          </div>

          <p className='text-xl'>
            Financeiro
          </p>
        </div>
      )}
      triggerClassName="py-0"
      bodyClassName="pt-4 pb-0"
      body={(
        <div className='flex flex-col gap-4'>
          <div className='flex items-center gap-2'>
            <p>
              Enviar fatura para processamento:
            </p>

            <div className='flex items-center gap-1 text-white-400'>
              <CircleChevronDownIcon strokeWidth={1.5} />

              <p>
                {company?.bill_integration_process ? billIntegrationProcess[company.bill_integration_process] : '--'}
              </p>
            </div>
          </div>

          <div className='flex flex-col gap-2'>
            <p>
              Tarifas especiais:
            </p>

            <div className='flex flex-col gap-3'>
              {Number(company?.fee_rule?.special_entries?.length) > 0 ? company?.fee_rule?.special_entries?.map((specialFee, i) => (
                <div key={`fee_template_${i}`} className='flex items-center gap-2'>
                  <CircleChevronDownIcon strokeWidth={1.5} className='text-white-400' />

                  <div>
                    <p className='italic text-xs font-light'>
                      Tarifa
                    </p>

                    <p>
                      {specialFee.fee_template.display_name}
                    </p>
                  </div>

                  <div className='flex items-center gap-2 ms-2'>
                    <DollarSignIcon strokeWidth={1.5} className='text-white-400' />

                    <div>
                      <p className='italic text-xs font-light'>
                        Valor
                      </p>

                      <p>
                        {specialFee.fee_template.calculate_as === 'percentage'
                          ? formatPercentage(Number(specialFee.value))
                          : formatCurrency(Number(specialFee.value))}
                      </p>
                    </div>
                  </div>
                </div>
              )) : (
                <p className='italic font-light'>
                  Não possui
                </p>
              )}
            </div>
          </div>
        </div>
      )}
    />
  )
}

export default FinancialSection;
